import headsetIcon from '@/assets/icons/headset.png'
import sunIcon from '@/assets/icons/sun.svg?url'
import completeBox from '@/assets/payment/complete-box.png'
import { CTAButton } from '@/components/ui/CTAButton'

import {
  CompleteBottomBar,
  CompleteContainer,
  CompleteHeading,
  CompleteHeadingSection,
  CompleteImage,
  CompleteImageWrap,
  CompleteScrollArea,
  CompleteSubheading,
  NoticeDesc,
  NoticeIcon,
  NoticeIconBox,
  NoticeItem,
  NoticeList,
  NoticeTexts,
  NoticeTitle,
} from './styles'

interface CompleteNotice {
  icon: string
  title: string
  description: string
}

const COMPLETE_NOTICES: CompleteNotice[] = [
  {
    icon: sunIcon,
    title: '내일 오전 11시까지 수량 변경 가능',
    description: '주소 변경은 취소 후 다시 신청해 주세요',
  },
  {
    icon: headsetIcon,
    title: '배송 요청사항은 고객센터로 문의',
    description: '부재 시 문 앞 배송 등을 남길 수 있어요',
  },
]

interface CompleteStepProps {
  /** "확인했어요" CTA 클릭 — Funnel 부모가 closeWebView 또는 onPrevious 등 처리 */
  onConfirm: () => void
}

export function CompleteStep({ onConfirm }: CompleteStepProps) {
  return (
    <CompleteContainer>
      <CompleteScrollArea>
        <CompleteHeadingSection>
          <CompleteHeading>밀봉비닐 신청 완료!</CompleteHeading>
          <CompleteSubheading>
            영업일 기준 <strong>3~4일</strong> 이내에 배송돼요
          </CompleteSubheading>
        </CompleteHeadingSection>
        <CompleteImageWrap>
          <CompleteImage
            src={completeBox}
            alt='밀봉비닐 배송 안내'
          />
        </CompleteImageWrap>
        <NoticeList>
          {COMPLETE_NOTICES.map((notice) => (
            <NoticeItem key={notice.title}>
              <NoticeIconBox>
                <NoticeIcon
                  src={notice.icon}
                  alt=''
                />
              </NoticeIconBox>
              <NoticeTexts>
                <NoticeTitle>{notice.title}</NoticeTitle>
                <NoticeDesc>{notice.description}</NoticeDesc>
              </NoticeTexts>
            </NoticeItem>
          ))}
        </NoticeList>
      </CompleteScrollArea>
      <CompleteBottomBar>
        <CTAButton
          variant='dark'
          onClick={onConfirm}
        >
          확인했어요
        </CTAButton>
      </CompleteBottomBar>
    </CompleteContainer>
  )
}
